import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IRootState } from "../../redux/states";
import { BaseState, StateKeys } from "../../redux/states/main.state";
import { EventResponse } from "../../services/api.response.service";
import {
  AppPageScrollDownLoadMore,
  AppState,
  CheckContentProviderIdExist,
  InfoLogger,
} from "../../services/app.service";
import Main from "../../redux/actions/main.action";
import ApiEndpoint from "../../services/api.endpoint.service";
import { Col } from "react-bootstrap";
import Loader from "../../components/Loader";
import EventCard from "../../components/EventCard";
import NoData from "./NoData";
import EventDetailsModal from "../../components/EventDetailsModal";
import Languages from "../../components/Languages";
import { useParams } from "react-router";
import {Mixpanel} from "../../services/mixpanel";

function Events() {
  const { id } = useParams<{ id: string }>();

  const dispatch = useDispatch();
  const state = useSelector((state: IRootState) => state.main);
  const details: BaseState<Array<EventResponse>> = state[StateKeys.EVENTS];
  const [showEventDetails, setShowEventDetails] = useState<EventResponse>();

  const stateAll = useSelector((state: IRootState) => state);
  const currentUser = stateAll.setting.user!;

  const [mp, setMp] = useState<boolean>(false);
  useEffect(() => {
    if (!mp) {
      Mixpanel.track('Events View', {
        'with': currentUser?.id ? "Auth" : "Guest",
        'user_id': currentUser?.id,
      });
      setMp(true);
    }
  }, []);


  useEffect(() => {
    if (details.pageState !== AppState.LOADED) {
      dispatch(
        Main.getPaginatedPageData({
          stateKey: StateKeys.EVENTS,
          apiEndpoint: ApiEndpoint.EVENTS,
          previousPage: 0,
          storeKey: StateKeys.EVENTS,
          params: CheckContentProviderIdExist()
            ? { content_provider_id: process.env.REACT_APP_CONTENT_PROVIDER_ID }
            : {},
        })
      );
    }
  }, []);

  const loadMore = () => {
    // @ts-ignore
    if (
      window.innerHeight + document.documentElement.scrollTop ===
      // @ts-ignore
      document.scrollingElement.scrollHeight
    ) {
      InfoLogger(details);
      // @ts-ignore
      if (details.hasMore && details.pageState !== AppState.LOADING_MORE) {
        InfoLogger(details);
        dispatch(
          Main.getPaginatedPageData({
            stateKey: StateKeys.EVENTS,
            apiEndpoint: ApiEndpoint.EVENTS,
            previousPage: details.currentPage!,
            storeKey: StateKeys.EVENTS,
          })
        );
      }
    }
  };

  useEffect(() => {
    details.data?.map((item) => {
      item.id === Number(id)
        ? setShowEventDetails(item)
        : setShowEventDetails(null!);
    });
  }, [details.data]);

  return (
    <div
      className="content-page scroller-hide"
      onScroll={(e) => AppPageScrollDownLoadMore(e, loadMore)}
    >
      <div className="content-card pe-4 mt-4 h-100 overflow-auto">
        <Col lg={12} className="row m-0 p-0">
          <Col sm={12} className="d-flex justify-content-between mt-1">
            <div className="header-title">
              <h4 className="card-title">Events </h4>
            </div>
          </Col>
          <Col sm={12} className="row m-0 p-0">
            {details.data.length > 0 ? (
              details.data.map((item) => (
                <Col
                  style={{ cursor: "pointer" }}
                  key={item.id}
                  sm={12}
                  md={4}
                  className="mt-1"
                  onClick={() => setShowEventDetails(item)}
                >
                  <EventCard data={item} />
                </Col>
              ))
            ) : (
              <></>
            )}
          </Col>
          <Col sm={12} className="row m-0 p-0">
            {(details.pageState === AppState.LOADING ||
              details.pageState === AppState.LOADING_MORE) && (
              <Loader noCard imageLoader />
            )}
          </Col>
          <Col sm={12} className="row m-0 p-0">
            {details.pageState === AppState.LOADED &&
              details.data.length === 0 && <NoData title="noEvents" />}
          </Col>
        </Col>
        <Col md={12}>
          {details.hasMore &&
            !(
              details.pageState === AppState.LOADING ||
              details.pageState === AppState.LOADING_MORE
            ) && (
              <div
                className={`w-100 text-center shadow-xss rounded-xxl border-0 px-3`}
              >
                <button
                  className="text-decoration-none btn btn-primary"
                  onClick={() => loadMore()}
                >
                  <Languages langKey="loadMore" />
                </button>
              </div>
            )}
        </Col>
        <EventDetailsModal
          details={showEventDetails!}
          setShowEventDetails={setShowEventDetails}
        />
      </div>{" "}
    </div>
  );
}

export default Events;
